/** "custom" badge next to a value that differs from its default, with a reset button. */
export function CustomMark({ label, onReset }: { label: string; onReset: () => void }) {
  return (
    <span className="ml-2 inline-flex items-center gap-1">
      <span className="rounded-full bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold text-amber-800">
        custom
      </span>
      <button
        type="button"
        onClick={onReset}
        title={label}
        aria-label={label}
        className="flex h-5 w-5 items-center justify-center rounded text-[var(--co-muted)] hover:bg-[var(--co-bg)] hover:text-[var(--co-text)]"
      >
        <svg viewBox="0 0 16 16" className="h-3 w-3" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M3 8a5 5 0 1 1 1.5 3.6M3 8V4.5M3 8h3.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </span>
  );
}
